const DIGITS = 6

export const OTPInput = {
  _inputs: [] as HTMLInputElement[],
  _hidden: null as HTMLInputElement | null,

  mounted(this: typeof OTPInput & { el: HTMLElement }) {
    const el = this.el
    this._hidden = el.querySelector<HTMLInputElement>("input[data-otp-hidden]")
    this._inputs = Array.from(el.querySelectorAll<HTMLInputElement>("input[data-otp-digit]"))

    this._inputs.forEach((input, i) => {
      input.addEventListener("keydown", (e) => this._onKeyDown(e, i))
      input.addEventListener("input", (e) => this._onInput(e as InputEvent, i))
      input.addEventListener("paste", (e) => this._onPaste(e, i))
      input.addEventListener("focus", () => input.select())
      input.addEventListener("click", () => input.select())
    })
  },

  _onKeyDown(
    this: typeof OTPInput & { el: HTMLElement },
    e: KeyboardEvent,
    index: number,
  ) {
    const input = this._inputs[index]

    if (e.key === "Backspace") {
      e.preventDefault()
      if (input.value) {
        input.value = ""
        this._sync()
      } else if (index > 0) {
        this._inputs[index - 1].focus()
        this._inputs[index - 1].value = ""
        this._sync()
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      e.preventDefault()
      this._inputs[index - 1].focus()
    } else if (e.key === "ArrowRight" && index < DIGITS - 1) {
      e.preventDefault()
      this._inputs[index + 1].focus()
    }
  },

  _onInput(
    this: typeof OTPInput & { el: HTMLElement },
    e: InputEvent,
    index: number,
  ) {
    const input = this._inputs[index]
    const val = input.value.replace(/\D/g, "")

    if (val.length > 1) {
      // multi-char: fill from this position
      const chars = val.slice(0, DIGITS - index).split("")
      chars.forEach((c, j) => {
        if (this._inputs[index + j]) this._inputs[index + j].value = c
      })
      const next = Math.min(index + chars.length, DIGITS - 1)
      this._inputs[next].focus()
    } else {
      input.value = val
      if (val && index < DIGITS - 1) {
        this._inputs[index + 1].focus()
      }
    }

    this._sync()
  },

  _onPaste(
    this: typeof OTPInput & { el: HTMLElement },
    e: ClipboardEvent,
    _index: number,
  ) {
    e.preventDefault()
    const text = e.clipboardData?.getData("text") ?? ""
    const digits = text.replace(/\D/g, "").slice(0, DIGITS)
    digits.split("").forEach((c, i) => {
      if (this._inputs[i]) this._inputs[i].value = c
    })
    const next = Math.min(digits.length, DIGITS - 1)
    this._inputs[next]?.focus()
    this._sync()
  },

  _sync(this: typeof OTPInput & { el: HTMLElement }) {
    const value = this._inputs.map((i) => i.value).join("")
    if (this._hidden) {
      this._hidden.value = value
      this._hidden.dispatchEvent(new Event("input", { bubbles: true }))
    }
  },
}
